import mutations from './drugPuphax.mutations'
import actions from './drugPuphax.actions'
import getters from './drugPuphax.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
